import React from 'react';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyGroupDetail = lazyForPaint<any>(
	() =>
		import(
			/* webpackChunkName: "async-jira-eoc-group-detail", jiraSpaEntry: "async-jira-eoc-group-detail" */ '@atlassian/jira-eoc-group-detail/src/ui/index.tsx'
		),
);

const AsyncGroupDetail = (): React.JSX.Element => (
	<LazyPage Page={LazyGroupDetail} pageId="async-jira-eoc-group-detail" shouldShowSpinner={false} />
);

export default AsyncGroupDetail;
